var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pr-1"},[_c('img',{staticClass:"copy copy-occupancy",attrs:{"src":require("@/assets/svg/copy.svg"),"alt":"copy"},on:{"click":_vm.copyOccupancy}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b158986","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatable/OccupancyTypeCopyButton.vue
// module id = null
// module chunks = 